import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { CheckBoxInputFieldState } from "@fidget/common/components/form/checkboxInput";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { ChipTag } from "../../../../../chip/presets/ChipTag/ChipTag";
import { VerticalSeparator } from "../../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import taggingStyles from "../../../taggingSettings/taggingSettings.css";
import styles from "../../tagsSettings.css";
import { ExistingTagFormType } from "../../types";

interface Props {
  form: ExistingTagFormType;
}
export const TagBox = observer(({ form }: Props) => {
  const { id, tag, enabled, required, priority, showInConversationDetails } = form.$;
  return (
    <div className={styles["form-content"]}>
      <div className={styles["tag-container"]}>
        <div className={classNames(taggingStyles["form-text"], taggingStyles["form-text-dimmed"])}>
          <L10n id={"settings.tagging.mapping.tag"} />
        </div>
        <div className={taggingStyles["bottom-input"]}>
          <ChipTag name={tag.$} enabled={enabled.$} />
        </div>
      </div>
      <div className={styles["form-container"]}>
        <VerticalSeparator />
        <div
          className={classNames(
            styles["inputs-container"],
            styles["checkbox-input"],
            styles["margin-right"]
          )}
        >
          <div className={styles["checkboxes-container"]}>
            <CheckBoxInputFieldState
              field={enabled}
              id={`enabled-${id.$}`}
              label={intl.formatMessage("settings.tags.tag.enabled")}
              smallStyle
              displayNoColors
            />
            <CheckBoxInputFieldState
              field={required}
              id={`required-${id.$}`}
              label={intl.formatMessage("settings.tags.tag.required")}
              smallStyle
              displayNoColors
            />
          </div>
        </div>
        <div className={classNames(styles["inputs-container"], styles["checkbox-input"])}>
          <CheckBoxInputFieldState
            field={priority}
            id={`priority-${id.$}`}
            label={intl.formatMessage("settings.tags.tag.priority")}
            smallStyle
            displayNoColors
          />
          <CheckBoxInputFieldState
            field={showInConversationDetails}
            id={`showInDetails-${id.$}`}
            label={intl.formatMessage("settings.tags.tag.showInDetails")}
            smallStyle
            displayNoColors
          />
        </div>
      </div>
    </div>
  );
});
